// Mock data for Hei Web Creations website

export const heroData = {
  title: "Premium Websites, Built Smarter with AI",
  subtitle: "We combine human expertise with AI-powered workflows to deliver stunning, conversion-focused websites faster and more affordably.",
  cta1: "Start Your Project",
  cta2: "View Our Work"
};

export const manifestoData = [
  {
    number: "01",
    title: "Human-Led Strategy",
    description: "Every project begins with understanding your business goals. Our experienced designers and strategists craft solutions tailored to your brand, ensuring authenticity and purpose."
  },
  {
    number: "02",
    title: "AI-Enhanced Efficiency",
    description: "We leverage cutting-edge AI to accelerate workflows, optimize structures, and enhance production—delivering premium quality faster without compromising on craftsmanship."
  },
  {
    number: "03",
    title: "Premium Quality, Smarter Value",
    description: "By streamlining processes with intelligent automation, we pass the savings to you. Get agency-grade websites at a fraction of traditional costs."
  },
  {
    number: "04",
    title: "Results-Driven Design",
    description: "Beautiful design means nothing without performance. We build websites that convert visitors into customers, combining aesthetics with strategic user experience."
  }
];

export const servicesData = [
  {
    id: 1,
    slug: "website-design",
    title: "Website Design",
    description: "Custom-designed websites that capture your brand essence and drive conversions. Built for performance, optimized for results.",
    benefits: ["Responsive design", "SEO-optimized", "Fast loading", "Conversion-focused"],
    icon: "Layout",
    tagline: "Beautiful, high-performing websites that convert.",
    longDescription: "Your website is often the first impression customers have of your business. We design custom websites that not only look stunning but are strategically built to convert visitors into customers. Every design decision is grounded in your brand identity, business goals, and user experience best practices.\n\nAs a leading web design company in Singapore, we combine premium aesthetics with technical excellence to deliver websites that perform beautifully across all devices.",
    features: [
      { title: "Bespoke Visual Design", description: "Unique designs tailored to your brand, never templated." },
      { title: "Mobile-First Approach", description: "Flawless experiences across desktop, tablet, and mobile." },
      { title: "SEO Foundations", description: "Built with clean code and structure to rank on Google." },
      { title: "Performance Optimized", description: "Fast-loading pages that keep visitors engaged." }
    ],
    idealClients: ["SMEs establishing an online presence", "Startups launching their brand", "Professional service firms", "Businesses wanting a premium refresh"]
  },
  {
    id: 2,
    slug: "wordpress-development",
    title: "WordPress Design & Development",
    description: "Powerful, flexible WordPress solutions that are easy to manage. Custom themes and plugins tailored to your needs.",
    benefits: ["Custom themes", "Easy management", "Scalable architecture", "Plugin development"],
    icon: "Code",
    tagline: "Flexible, scalable WordPress websites you control.",
    longDescription: "WordPress powers over 40% of the web for good reason — it's flexible, scalable, and easy to manage. As an experienced WordPress developer in Singapore, we build custom WordPress websites with bespoke themes and functionality that give you full control over your content.\n\nWhether you need a corporate site, blog, or complex custom solution, we deliver WordPress builds that are secure, fast, and simple to update.",
    features: [
      { title: "Custom Theme Development", description: "Tailor-made themes built for your exact requirements." },
      { title: "Plugin Integration", description: "Extended functionality with the right plugins and custom code." },
      { title: "Easy Content Management", description: "Update your site effortlessly with an intuitive dashboard." },
      { title: "Scalable & Secure", description: "Built to grow with your business and stay protected." }
    ],
    idealClients: ["Content-driven businesses", "Companies needing self-managed sites", "Blogs and publications", "Growing organizations"]
  },
  {
    id: 3,
    slug: "woocommerce",
    title: "WooCommerce Development",
    description: "Complete e-commerce solutions with seamless payment integration, inventory management, and user-friendly shopping experiences.",
    benefits: ["Payment gateway setup", "Product management", "Shipping integration", "Mobile-optimized checkout"],
    icon: "ShoppingCart",
    tagline: "Complete online stores that sell.",
    longDescription: "Turn your products into profit with a professionally built WooCommerce store. As a trusted WooCommerce developer in Singapore, we handle everything from store setup to launch — creating shopping experiences that are seamless, secure, and built to maximize sales.\n\nWe design intuitive product catalogues, integrate reliable payment gateways, configure shipping, and optimize the entire checkout journey for conversions.",
    features: [
      { title: "Online Store Setup", description: "Full WooCommerce configuration, ready to sell from day one." },
      { title: "Product Catalogue Design", description: "Beautiful, organized product pages that showcase your items." },
      { title: "Payment Gateway Integration", description: "Secure payments via Stripe, PayPal, and local options." },
      { title: "Shipping Setup", description: "Flexible shipping rules, zones, and rate configuration." },
      { title: "User-Friendly Shopping Experience", description: "Smooth, mobile-optimized checkout that reduces cart abandonment." }
    ],
    idealClients: ["Retailers moving online", "Product-based businesses", "Brands scaling e-commerce", "Entrepreneurs launching stores"]
  },
  {
    id: 4,
    slug: "portal-development",
    title: "Portal Design & Development",
    description: "Custom web portals for internal operations, client management, or member services. Secure, scalable, and intuitive.",
    benefits: ["User authentication", "Role-based access", "Custom dashboards", "API integrations"],
    icon: "Globe",
    tagline: "Secure, custom portals that streamline operations.",
    longDescription: "Web portals centralize your operations, connect your teams, and serve your members or clients better. As a specialist in portal development in Singapore, we build secure, custom portals with role-based access, tailored dashboards, and integrations that fit your workflow.\n\nFrom client portals to internal management systems, we create intuitive platforms that make complex processes simple.",
    features: [
      { title: "User Authentication", description: "Secure login and account management for all user types." },
      { title: "Role-Based Access", description: "Granular permissions to control who sees what." },
      { title: "Custom Dashboards", description: "Tailored interfaces that surface the right data at a glance." },
      { title: "API Integrations", description: "Connect with your existing tools and third-party services." }
    ],
    idealClients: ["Corporates needing internal systems", "Membership organizations", "Service firms managing clients", "Businesses digitizing operations"]
  },
  {
    id: 5,
    slug: "ai-assisted-creation",
    title: "AI-Assisted Website Creation",
    description: "Harness the power of AI to accelerate your website development. Faster turnaround, smarter workflows, premium results.",
    benefits: ["Rapid prototyping", "Intelligent automation", "Cost-effective", "Quality assured"],
    icon: "Sparkles",
    tagline: "Premium websites, delivered smarter and faster.",
    longDescription: "Our AI-enhanced workflow is what sets us apart. By leveraging AI for planning, structure, and production, we deliver premium websites faster and more affordably — without ever compromising on design quality or strategy.\n\nAI web design in Singapore doesn't mean cutting corners. It means smarter processes, faster turnaround, and better value, with every project still guided by experienced human designers.",
    features: [
      { title: "Rapid Prototyping", description: "See your concepts come to life in days, not weeks." },
      { title: "Intelligent Automation", description: "AI handles repetitive tasks so we focus on craft." },
      { title: "Cost-Effective Delivery", description: "Streamlined workflows mean savings we pass to you." },
      { title: "Human Quality Control", description: "Every output reviewed and refined by our expert team." }
    ],
    idealClients: ["Startups on tight timelines", "Budget-conscious SMEs", "Businesses wanting speed and quality", "Anyone needing a fast launch"]
  },
  {
    id: 6,
    slug: "website-redesign",
    title: "Website Revamp / Redesign",
    description: "Breathe new life into your existing website. Modern design, improved performance, enhanced user experience.",
    benefits: ["Modern aesthetics", "Performance optimization", "UX improvements", "Brand alignment"],
    icon: "RefreshCw",
    tagline: "Transform your outdated site into a modern asset.",
    longDescription: "Is your website looking dated or underperforming? A strategic redesign can dramatically improve your brand perception, user experience, and conversion rates. We revamp existing websites with modern design, faster performance, and a refreshed user journey.\n\nWe preserve what works, fix what doesn't, and elevate your online presence to match where your business is today.",
    features: [
      { title: "Modern Aesthetics", description: "Contemporary design that reflects your current brand." },
      { title: "Performance Optimization", description: "Faster load times and improved technical health." },
      { title: "UX Improvements", description: "Refined user journeys that drive engagement and action." },
      { title: "Brand Alignment", description: "Consistent visuals that match your evolved identity." }
    ],
    idealClients: ["Businesses with outdated sites", "Companies after a rebrand", "Sites with poor performance", "Brands seeking better conversions"]
  },
  {
    id: 7,
    slug: "maintenance-support",
    title: "Maintenance & Support",
    description: "Keep your website running smoothly with ongoing maintenance, updates, and dedicated support. Peace of mind guaranteed.",
    benefits: ["Regular updates", "Security monitoring", "Performance optimization", "24/7 support"],
    icon: "Shield",
    tagline: "Ongoing care to keep your site secure and fast.",
    longDescription: "A website needs ongoing care to stay secure, fast, and up-to-date. Our maintenance and support packages give you peace of mind, handling everything from software updates and security monitoring to performance tuning and content changes.\n\nFocus on running your business while we keep your website in perfect shape.",
    features: [
      { title: "Regular Updates", description: "Software, plugins, and security patches kept current." },
      { title: "Security Monitoring", description: "Proactive protection against threats and vulnerabilities." },
      { title: "Performance Optimization", description: "Ongoing tuning to keep your site loading fast." },
      { title: "Dedicated Support", description: "A responsive team ready to help whenever you need." }
    ],
    idealClients: ["Businesses without in-house tech", "Sites requiring reliability", "E-commerce stores", "Any business valuing peace of mind"]
  }
];

export const statsData = [
  { value: "150+", label: "Projects Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "50%", label: "Faster Turnaround" },
  { value: "40%", label: "Cost Savings" }
];

export const whyAIData = {
  title: "Why AI-Enhanced?",
  subtitle: "The best of both worlds: human creativity meets machine efficiency",
  benefits: [
    {
      title: "Accelerated Planning",
      description: "AI helps us analyze requirements, structure content, and create wireframes in minutes—not days. This means faster project kickoff and more time for refinement."
    },
    {
      title: "Enhanced Efficiency",
      description: "Automated workflows handle repetitive tasks, code generation, and optimization. Our team focuses on strategy, design, and the creative touches that matter."
    },
    {
      title: "Quality Control",
      description: "AI-powered testing and validation catch issues before they reach you. Every website is thoroughly checked for performance, accessibility, and responsiveness."
    },
    {
      title: "Human Expertise Still Essential",
      description: "AI is a powerful tool, but it can't replace human intuition, creativity, and strategic thinking. Every project is guided by experienced professionals who ensure quality and authenticity."
    },
    {
      title: "Better Value for Clients",
      description: "By reducing overhead and accelerating workflows, we pass the savings directly to you—premium quality at competitive prices."
    }
  ]
};

export const aboutData = {
  title: "About Hei Web Creations",
  tagline: "Where Human Expertise Meets Intelligent Workflows",
  story: "Founded in Singapore, Hei Web Creations was built on a simple belief: technology should enhance creativity, not replace it. We combine years of web design expertise with cutting-edge AI tools to deliver websites that are both beautiful and effective.\n\nOur team of designers, developers, and strategists use AI to streamline workflows, accelerate production, and reduce costs—but every project is guided by human insight, creativity, and strategic thinking.\n\nWe don't build 'AI websites.' We build premium websites, smarter.",
  values: [
    {
      title: "Quality First",
      description: "Every pixel, every interaction, every line of code meets our high standards."
    },
    {
      title: "Client Partnership",
      description: "Your success is our success. We work closely with you at every stage."
    },
    {
      title: "Innovation",
      description: "We embrace new technologies that help us deliver better results faster."
    },
    {
      title: "Transparency",
      description: "Clear communication, honest timelines, and straightforward pricing."
    }
  ]
};

export const testimonialsData = [
  {
    quote: "Hei Web Creations delivered a stunning website in half the time we expected. The quality exceeded our expectations.",
    author: "Dr Vivien Yang",
    position: "Director / Principal Educational Psychologist",
    company: "Bloom Child Psychology"
  },
  {
    quote: "Professional, efficient, and incredibly talented. Our new WooCommerce store has already increased conversions by 40%.",
    author: "Judy Wong",
    position: "Business Owner",
    company: "Kwong Satay"
  },
  {
    quote: "The perfect balance of creativity and technical expertise. They understood our vision and brought it to life beautifully.",
    author: "Michael Tan",
    position: "Co-Founder",
    company: "EBAT"
  }
];

export const contactFormFields = [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "company", label: "Company", type: "text", required: false },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel", required: false },
  { name: "projectType", label: "Project Type", type: "select", required: true, options: [
    "Website Design",
    "WordPress Development",
    "WooCommerce Store",
    "Portal Development",
    "Website Redesign",
    "Maintenance & Support",
    "Other"
  ]},
  { name: "budget", label: "Budget Range", type: "select", required: false, options: [
    "Under $5,000",
    "$5,000 - $10,000",
    "$10,000 - $25,000",
    "$25,000+",
    "Not sure yet"
  ]},
  { name: "timeline", label: "Timeline", type: "select", required: false, options: [
    "ASAP",
    "1-2 months",
    "3-4 months",
    "Flexible"
  ]},
  { name: "message", label: "Tell us about your project", type: "textarea", required: true }
];

export const faqData = [
  {
    question: "How does AI-assisted development work?",
    answer: "We use AI tools to accelerate planning, structure content, generate code scaffolding, and optimize workflows. However, all strategic decisions, design work, and final implementation are handled by our experienced team. This approach gives you the best of both worlds: efficiency and expertise."
  },
  {
    question: "What's the typical project timeline?",
    answer: "Thanks to our AI-enhanced workflows, we can deliver projects 40-50% faster than traditional agencies. A typical website takes 2-4 weeks, depending on complexity. We'll provide a detailed timeline during consultation."
  },
  {
    question: "Do you provide ongoing support?",
    answer: "Absolutely. We offer maintenance packages including regular updates, security monitoring, performance optimization, and technical support. Your website will stay secure, fast, and up-to-date."
  },
  {
    question: "Can you work with our existing brand guidelines?",
    answer: "Yes! We can work within your existing brand identity or help you develop a new one. Our designers ensure consistency across all touchpoints."
  },
  {
    question: "What makes you different from other web agencies?",
    answer: "We combine traditional agency-grade quality with AI-enhanced efficiency. You get premium design and development at more competitive prices, with faster turnaround times—without compromising on quality or service."
  }
];

export const footerData = {
  company: "Hei Web Creations Pte Ltd",
  tagline: "Premium websites, built smarter with AI.",
  address: "100 Peck Seah St, #07-07 Singapore 079333",
  email: "hello@heiwebcreations.com",
  phone: "+65 9888 3331",
  social: [
    { platform: "LinkedIn", url: "#", icon: "Linkedin" },
    { platform: "Instagram", url: "#", icon: "Instagram" },
    { platform: "Facebook", url: "#", icon: "Facebook" }
  ],
  links: {
    services: [
      { label: "Website Design", url: "/services/website-design" },
      { label: "WordPress Development", url: "/services/wordpress-development" },
      { label: "WooCommerce", url: "/services/woocommerce" },
      { label: "Portal Development", url: "/services/portal-development" },
      { label: "AI-Assisted Creation", url: "/services/ai-assisted-creation" },
      { label: "Website Redesign", url: "/services/website-redesign" },
      { label: "Maintenance & Support", url: "/services/maintenance-support" }
    ],
    company: [
      { label: "About Us", url: "/about" },
      { label: "Why AI", url: "/why-ai" },
      { label: "Blog", url: "/blog" },
      { label: "Contact", url: "/contact" }
    ]
  }
};

export const marqueeText = "Premium Web Design • WordPress Development • WooCommerce Stores • AI-Enhanced Workflows • Singapore-Based • ";

export const featuredServices = [
  {
    id: 1,
    title: "AI Chatbot Integration",
    description: "24/7 automated customer support and lead qualification that never sleeps — converting visitors into qualified leads around the clock.",
    icon: "Bot",
  },
  {
    id: 2,
    title: "Native Mobile App Development",
    description: "Custom iOS & Android apps built for engagement, performance, and a seamless brand experience in your customers' pockets.",
    icon: "Smartphone",
  },
  {
    id: 3,
    title: "Enterprise Web Design",
    description: "SEO-optimized, ultra-fast, and mobile-perfect corporate sites engineered to elevate your brand and drive measurable growth.",
    icon: "Globe",
  },
];

export const portfolioData = [
  {
    id: 1,
    title: "Bloom Child Psychology",
    category: "Website Design",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: 2,
    title: "Kwong Satay",
    category: "WooCommerce Store",
    image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "EBAT Platform",
    category: "Portal Development",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: 4,
    title: "Prestige Consulting",
    category: "WordPress Development",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: 5,
    title: "Urban Lifestyle",
    category: "Website Redesign",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: 6,
    title: "TechStart Solutions",
    category: "AI-Assisted Creation",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80&auto=format&fit=crop",
  },
];


// Detailed case studies for /case-studies/:slug — real client work shipped by Hei Web Creations.
// Each case study showcases the S$3,999 Growth Bundle (Logo + Website + SEO + Social Media).
export const caseStudiesData = [
  {
    slug: "kwong-satay",
    title: "Kwong Satay",
    tagline: "From queues at Geylang to a booming direct-to-consumer ordering platform.",
    liveUrl: "https://kwongsatay.com.sg/",
    industry: "Food & Beverage",
    location: "Singapore",
    year: "2025",
    heroImage:
      "https://images.unsplash.com/photo-1529563021893-cc83c992d75d?w=1600&q=80&auto=format&fit=crop",
    thumbnail:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&q=80&auto=format&fit=crop",
    services: ["Logo Refresh", "WooCommerce Website", "Local SEO", "Social Media Kit"],
    package: "Growth Bundle · S$3,999",
    keywords: [
      "best satay singapore",
      "satay delivery singapore",
      "halal satay geylang",
      "kwong satay online order",
    ],
    problem:
      "A beloved heritage satay brand with hour-long queues in-store, but zero digital ordering. Third-party delivery apps were taking a 30% commission on every order — bleeding margin on their signature product.",
    solution:
      "We rebuilt the brand into a lean WooCommerce store: mobile-first menu, chilled islandwide delivery scheduling, in-store pickup, and structured-data-rich product pages. Paired with a brand-consistent Instagram kit and local SEO tuned for Singapore search intent.",
    outcome: [
      { metric: "+180%", label: "direct online orders in 90 days" },
      { metric: "4×", label: "keywords ranking on page 1" },
      { metric: "0%", label: "third-party commission on repeat orders" },
    ],
    techStack: ["WooCommerce", "Custom WordPress Theme", "Stripe SG", "Local SEO Schema"],
  },
  {
    slug: "bloom-child-psychology",
    title: "Bloom Child Psychology",
    tagline: "A warm, authoritative digital home for a private psychology practice.",
    liveUrl: "https://www.bloomchildpsy.com/",
    industry: "Healthcare · Psychology",
    location: "Singapore",
    year: "2024",
    heroImage:
      "https://images.unsplash.com/photo-1607453998774-d533f65dac99?w=1600&q=80&auto=format&fit=crop",
    thumbnail:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80&auto=format&fit=crop",
    services: ["Brand Identity", "WordPress Website", "SEO Strategy", "Social Media Templates"],
    package: "Growth Bundle · S$3,999",
    keywords: [
      "child psychologist singapore",
      "ADHD assessment singapore",
      "dyslexia assessment singapore",
      "autism assessment singapore",
    ],
    problem:
      "A specialist child & adolescent psychology practice — expert team, but a website that buried key services under generic templated pages. Parents couldn't tell what was on offer, or trust the practice at a glance.",
    solution:
      "A calming, editorial brand system built around 'bloom with grace'. Dedicated service pages for Assessment, Therapy, Consultation and Social Skills — each with clear next steps. Layered with credibility signals (memberships, testimonials) and long-tail SEO targeting how parents actually search.",
    outcome: [
      { metric: "3×", label: "organic enquiries in 6 months" },
      { metric: "Top 5", label: "for 'child psychologist singapore'" },
      { metric: "94", label: "PageSpeed mobile score" },
    ],
    techStack: ["WordPress", "Custom Theme", "Contact Forms 7", "Structured Data"],
  },
  {
    slug: "asia-green",
    title: "Asia Green",
    tagline: "A corporate rebrand for a sustainability leader — designed to convert boardrooms.",
    liveUrl: "https://www.asiagreen.com.sg/",
    industry: "Sustainability · B2B",
    location: "Singapore",
    year: "2025",
    heroImage:
      "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1600&q=80&auto=format&fit=crop",
    thumbnail:
      "https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=800&q=80&auto=format&fit=crop",
    services: ["Logo & Brand Guidelines", "Corporate Website", "SEO", "LinkedIn Content Kit"],
    package: "Growth Bundle · S$3,999",
    keywords: [
      "sustainability consulting singapore",
      "green solutions singapore",
      "esg consulting singapore",
      "asia green",
    ],
    problem:
      "An established sustainability firm competing against nimble startups on Google. Their old site read like a brochure from 2015 — no clear service categorisation, no case studies, no conversion path for enterprise procurement teams.",
    solution:
      "A modern editorial corporate site with sharp service architecture, downloadable capability decks, and case-study pages that speak to procurement, ESG, and facilities teams. SEO tuned for competitive B2B queries; LinkedIn content templates for the sales team.",
    outcome: [
      { metric: "+240%", label: "qualified B2B enquiries YoY" },
      { metric: "92", label: "PageSpeed mobile score" },
      { metric: "12", label: "commercial keywords in top 10" },
    ],
    techStack: ["WordPress", "Custom Blocks", "CDN + Image Optimisation", "SEO Schema"],
  },
  {
    slug: "sgjb-taxi",
    title: "SGJB Taxi",
    tagline: "The cross-border taxi service, finally bookable in two taps.",
    liveUrl: "https://sgjbtaxi.sg/",
    industry: "Transport · Logistics",
    location: "Singapore ⇄ Johor Bahru",
    year: "2025",
    heroImage:
      "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1600&q=80&auto=format&fit=crop",
    thumbnail:
      "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=800&q=80&auto=format&fit=crop",
    services: ["Logo Design", "Booking Website", "Local SEO", "Social Media Ads Kit"],
    package: "Growth Bundle · S$3,999",
    keywords: [
      "singapore to jb taxi",
      "jb to singapore taxi",
      "cross border taxi singapore",
      "sgjb taxi booking",
    ],
    problem:
      "Bookings ran entirely through WhatsApp — messy, hard to scale, invisible to Google. Competitors with slick apps were eating market share on high-intent search terms like 'singapore to jb taxi'.",
    solution:
      "A booking-first single-page website with route-based pricing, instant WhatsApp click-to-book, and rich structured data. Local SEO tightly targeted at cross-border commuter search terms; a lightweight social ads kit for weekend promo campaigns.",
    outcome: [
      { metric: "5×", label: "online booking share vs WhatsApp-only" },
      { metric: "#1", label: "ranking for 'singapore to jb taxi'" },
      { metric: "< 2s", label: "load time on 4G mobile" },
    ],
    techStack: ["Custom React Site", "WhatsApp Business API", "Local SEO Schema"],
  },
];
